import { getDataByStep , sleep } from '@/utils/outline'
import bluebird from 'bluebird'
import { cloneDeep } from 'lodash'
import { useModel } from 'umi'
import { v4 as uuidV4 } from 'uuid'

const cacheData = [
  'Understanding',
  'Customer',
  ' ',
  'Needs',
  ' ',
  'Creating',
  ' ',
  'Successful',
  ' ',
  'Marketing',
  ' ',
  'Plan',
  ' ',
  ';',
  'Customer',
  ' ',
  'Needs',
  ';',
  'Creating',
  ' ',
  'Successful',
  ' ',
  'Marketing',
  ' ',
  'Plan',
  ';',
  'Building',
  ' ',
  'Strong',
  ' ',
  'Brand',
]

const useAIWritingModelMock = () => {
  const { aiOutlineRefs, stopAIRequestRef, updateAIOutlines, setAiWritingLoadding, updateAIOutlineRequestStatusRef } = useModel('aiWritingModel')

  let timer: any
  const commonTime = 30

  // 获取大纲
  const getAIOutlineListMock = async () => {
    stopAIRequestRef.current = false
    updateAIOutlineRequestStatusRef({
      begin: true,
      outlineLoading: true,
      outlineLoaded: false,
      titleLoading: true,
    })

    await sleep(1000)
    let isClosed = false
    let num = 0
    return new Promise(async (resolve) => {
      let currentIndex = 0 // 大纲下标
      updateAIOutlineRequestStatusRef({
        titleLoadingPosition: currentIndex,
      })

      const res = getDataByStep (cacheData, stopAIRequestRef)
      timer = setInterval(() => {
        if (num === cacheData.length) {
          isClosed = true
        }
        const data = res.next(isClosed)
        num++
        const newOutline = aiOutlineRefs.current
        if (data.done) {
          updateAIOutlineRequestStatusRef({
            titleLoading: false,
            titleLoaded: true,
          })
          clearInterval(timer)
          resolve('')
          return
        }

        // 调节大纲数量，方便调试
        if (currentIndex > 5) {
          updateAIOutlineRequestStatusRef({
            titleLoading: false,
            titleLoaded: true,
          })
          clearInterval(timer)
          resolve('')
          return
        }

        if (!newOutline[currentIndex]) {
          newOutline[currentIndex] = {
            id: uuidV4(),
            title: '',
            concepts: [],
          }
        }

        // 根据分割符，要做一些列状态更新
        if (data.value === ';') {
          currentIndex++
          return
        }

        newOutline[currentIndex].title += data.value
        updateAIOutlines(cloneDeep(newOutline))
      }, commonTime)
    })
  }

  // 获取大纲的写作问题（mock数据、批量获取）
  const getAIOutlineConceptByBatchMock = async () => {
    updateAIOutlineRequestStatusRef({
      conceptLoading: true,
      conceptLoaded: false,
    })
    await bluebird.map(aiOutlineRefs.current, async (item, idx) => {
      // 获取单个大纲的写作问题
      await getAIConceptBySingleOutlineMock(idx)
    })
  }

  // 获取单个大纲的写文思路
  const getAIConceptBySingleOutlineMock = async (outlineIndex: number) => {
    let temTimer: any
    let isClosed = false
    let num = 0

    return new Promise(async (resolve) => {
      let conceptIndex = 0
      // 更新当前正在获取写文思路的大纲下标
      updateAIOutlineRequestStatusRef({
        conceptLoading: true,
      })

      const res = getDataByStep (cacheData, stopAIRequestRef)
      temTimer = setInterval(() => {
        if (num === cacheData.length) {
          isClosed = true
        }
        const data = res.next(isClosed)
        num++
        if (data.done) {
          clearInterval(temTimer)
          resolve('')
        }

        if (aiOutlineRefs.current.length === 0) {
          return
        }
        const { concepts } = aiOutlineRefs.current[outlineIndex]
        // 根据分割符，要做一些列状态更新
        if (data.value === ';') {
          conceptIndex++
          concepts[conceptIndex] = {
            id: uuidV4(),
            question: '',
            answerLoading: true,
            answerLoaded: false,
          }
          updateAIOutlines(cloneDeep(aiOutlineRefs.current))
          return
        }
        if (!concepts[conceptIndex]) {
          concepts[conceptIndex] = {
            id: uuidV4(),
            question: '',
            answer: '',
          }
        }
        concepts[conceptIndex].question += data.value
        updateAIOutlines(cloneDeep(aiOutlineRefs.current))
      }, commonTime)
    })
  }

  // 批量获取所有大纲的写文思路的取数
  const getConceptAnswerByBatchMock = async () => {
    console.log('开始取数')
    updateAIOutlineRequestStatusRef({
      conceptLoading: false,
      conceptLoaded: true,
      referenceLoaded: false,
      referenceLoading: true,
    })

    // 并发处理
    await bluebird.map(aiOutlineRefs.current, async (item, idx) => {
      await bluebird.map(item.concepts, async (concept, conceptIndex) => {
        await getSingleConceptAnswerMock(idx, conceptIndex)
      })
    })
  }

  // 获取单个写文思路的取数（Mock）
  const getSingleConceptAnswerMock = async (outlineIndex: number, conceptIndex: number) => {
    const data = aiOutlineRefs.current[outlineIndex].concepts[conceptIndex]
    aiOutlineRefs.current[outlineIndex].concepts[conceptIndex] = {
      ...data,
      answerLoaded: false,
      answerLoading: true,
    }
    updateAIOutlines(cloneDeep(aiOutlineRefs.current))
    // 模拟
    await sleep(1000 * (Math.random() + 0.2))
    aiOutlineRefs.current[outlineIndex].concepts[conceptIndex] = {
      ...data,
      answer: '这是一段测试',
      answerStatus: Math.random() > 0.5 ? true : false,
      answerLoaded: true,
      answerLoading: false,
    }
    updateAIOutlines(cloneDeep(aiOutlineRefs.current))
  }

  // 编辑大纲标题后的重新生成
  const generateNewAIOutlineMock = async (outlineIndex: number) => {
    setAiWritingLoadding(true)
    updateAIOutlineRequestStatusRef({
      outlineLoading: true,
      outlineLoaded: false,
      conceptLoaded: false,
      conceptLoading: true,
      referenceLoading: false,
      referenceLoaded: false,
    })

    // 重新生成写文思路
    await getAIConceptBySingleOutlineMock(outlineIndex)
    updateAIOutlineRequestStatusRef({
      conceptLoading: false,
      conceptLoaded: true,
      referenceLoaded: false,
      referenceLoading: true,
    })
    const concepts = aiOutlineRefs.current[outlineIndex].concepts
    // 并发获取写文思路的取数
    await bluebird.map(concepts, async (concept, conceptIndex) => {
      await getSingleConceptAnswerMock(outlineIndex, conceptIndex)
    })

    updateAIOutlineRequestStatusRef({
      outlineLoading: false,
      outlineLoaded: true,
      referenceLoaded: true,
      referenceLoading: false,
    })
    setAiWritingLoadding(false)
    console.log('mock，重新生成结束')
  }

  //  编辑某个写问思路后的重新生成
  const generateNewConceptAnswerMock = async (outlineIndex: number, conceptIndex: number) => {
    setAiWritingLoadding(true)
    updateAIOutlineRequestStatusRef({
      outlineLoading: true,
      outlineLoaded: false,
      referenceLoading: true,
      referenceLoaded: false,
    })

    await getSingleConceptAnswerMock(outlineIndex, conceptIndex)
    updateAIOutlineRequestStatusRef({
      outlineLoading: false,
      outlineLoaded: true,
      referenceLoading: false,
      referenceLoaded: true,
    })
    setAiWritingLoadding(false)
    console.log('mock，重新生成结束.')

  }

  // 初始化大纲和写作问题
  const initAIOutlineMock = async () => {
    await getAIOutlineListMock()
    await getAIOutlineConceptByBatchMock()
    await getConceptAnswerByBatchMock()
    console.log('mock流程结束')
    setAiWritingLoadding(false)
    updateAIOutlineRequestStatusRef({
      outlineLoading: false,
      outlineLoaded: true,
    })
  }

  return {
    initAIOutlineMock,
    getAIOutlineListMock,
    getAIOutlineConceptByBatchMock,
    generateNewAIOutlineMock,
    generateNewConceptAnswerMock,
  }
}

export default useAIWritingModelMock
